import { DEFAULT_REPAT, sanitizeRepat } from "../model/repatriation.ts";
import type { RepatriationInputs } from "../model/repatriation.ts";

/**
 * The USD to INR planner's figures live in this browser only (localStorage),
 * and are shared with the corpus calculator so it can compare the corpus
 * needed with the person's US savings. Nothing is sent anywhere.
 */
const STORAGE_KEY = "fatfire-repatriation-v1";

export function loadRepat(): RepatriationInputs {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? sanitizeRepat(JSON.parse(raw)).inputs : DEFAULT_REPAT;
  } catch {
    return DEFAULT_REPAT;
  }
}

export function saveRepat(p: RepatriationInputs): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(p));
  } catch {
    /* storage unavailable: the page still works for this visit */
  }
}

/** True while the planner still holds the built-in example, not the person's own figures. */
export function isExampleRepat(p: RepatriationInputs): boolean {
  return canonical(p) === canonical(DEFAULT_REPAT);
}

/** JSON with keys sorted at every level, so key order never affects the comparison. */
function canonical(v: unknown): string {
  if (Array.isArray(v)) return `[${v.map(canonical).join(",")}]`;
  if (v && typeof v === "object") {
    const o = v as Record<string, unknown>;
    return `{${Object.keys(o).sort().map((k) => `${JSON.stringify(k)}:${canonical(o[k])}`).join(",")}}`;
  }
  return JSON.stringify(v);
}
